import { getQueryParams, removeQueryParam } from '@wk/wk-uni-lib';
import dayjs from 'dayjs';
import cookie from 'js-cookie';
import { useEffect } from 'react';

import { refreshToken } from '@/api/authorized';
import {
  LAST_REFRESH_TIME,
  NEED_REFRESH_TOKEN_DAY,
  NO_AUTH_PATHS,
  REFRESH_TOKEN,
  TOKEN,
} from '@/constants';
import CacheStorage from '@/utils/cache-storage';
import { goWebSite } from '@/utils/go-web-site';
import {
  isTourist,
  removeRealToken,
  removeTokenInfo,
  setRealToken,
  setTokenInfo,
} from '@/utils/helpers';

const useAuth = () => {
  useEffect(() => {
    if (NO_AUTH_PATHS.includes(window.location.pathname)) {
      return;
    }

    const tourist = isTourist();
    const { token: urlToken } = getQueryParams();

    if (tourist) {
      // 临时存储 sign，手机号校验后清除
      removeRealToken();
    }

    if (urlToken) {
      if (
        [':3000/', '-3000.'].some((val: string) =>
          window.location.href.includes(val),
        )
      ) {
        cookie.set(TOKEN, urlToken.toString(), { expires: 30 });
      } else {
        setRealToken(urlToken.toString());
      }
      const newHref = removeQueryParam(window.location.href, 'token');
      window.history.replaceState({}, '', newHref);
      window.location.reload();
    }

    const token = CacheStorage.getItem<string>(TOKEN);
    const lastRefreshTime = CacheStorage.getItem<string>(LAST_REFRESH_TIME);

    if (!tourist && !token) {
      goWebSite();
      return;
    }

    if (
      token &&
      CacheStorage.getItem(REFRESH_TOKEN) &&
      (!lastRefreshTime ||
        dayjs().add(NEED_REFRESH_TOKEN_DAY, 'day').unix() > +lastRefreshTime)
    ) {
      refreshToken({
        refreshToken: CacheStorage.getItem(REFRESH_TOKEN),
      })
        .then(res => {
          const { content } = res || {};
          const { token: newToken, refreshToken: newRefreshToken } =
            content || {};
          if (newToken && newRefreshToken) {
            setTokenInfo(newToken, newRefreshToken);
          } else {
            removeTokenInfo(null, true);
          }
        })
        .catch(e => {
          console.error(e, 'useAuth catch');
          removeTokenInfo(null, true);
        });
    }
  }, []);
};

export default useAuth;
